// extracted by mini-css-extract-plugin
module.exports = {"signUpBanner":"SignUp--signUpBanner--3m9zI","form":"SignUp--form--2wQit","mini":"SignUp--mini--22KO1","successMessage":"SignUp--successMessage--EiENZ"};